import { Link, NavLink } from 'react-router-dom';
import { Crown } from 'lucide-react';
import { useAuth } from '../context/AuthContext.jsx';

/* bare: header-only chrome for full-bleed pages that bring their own body
   and footer (the /welcome landing) — keeps the sticky app navbar on top so
   there is always a way back into the app. */
export default function Layout({ children, bare }) {
  const { user, logout, loading } = useAuth();
  const isAdmin = user?.role === 'admin';

  return (
    <>
      <header>
        <nav className="navbar navbar-expand-sm navbar-dark">
          <div className="container-fluid">
            <Link className="navbar-brand" to="/">
              <span className="brand-noni">STREAM</span>
              <span className="brand-void">GG</span>
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#mainNav"
              aria-controls="mainNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="navbar-collapse collapse d-sm-inline-flex justify-content-between" id="mainNav">
              <ul className="navbar-nav flex-grow-1">
                {/* Public marketing landing — ungated on purpose, listed first. */}
                <li className="nav-item">
                  <NavLink className="nav-link" to="/welcome">
                    Welcome
                  </NavLink>
                </li>
                {user && (
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/" end>
                      Dashboard
                    </NavLink>
                  </li>
                )}
                {/* My Requests nav link intentionally hidden for now — the
                    /my-requests route still works for direct links. Restore
                    the NavLink here when the feature resurfaces. */}
                {isAdmin && (
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/admin">
                      Admin
                    </NavLink>
                  </li>
                )}
              </ul>
              {user && (
                <ul className="navbar-nav ms-auto">
                  <li className="nav-item d-flex align-items-center">
                    <span className="navbar-text text-muted me-3 nav-user">
                      <span className="nav-avatar" aria-hidden="true">
                        {user.name?.[0]?.toUpperCase() ?? '?'}
                      </span>
                      {user.name}
                      {isAdmin && (
                        <span className="admin-crown ms-2">
                          <Crown size={13} aria-hidden="true" />
                          ADMIN
                        </span>
                      )}
                    </span>
                    <button
                      type="button"
                      className="nav-logout"
                      onClick={() => logout()}
                    >
                      Logout
                    </button>
                  </li>
                </ul>
              )}
              {/* Signed-out visitors (public landing) get a Login button in
                  the far corner, mirroring where Logout sits when signed in.
                  Gated on !loading so it never flashes mid session-check. */}
              {!loading && !user && (
                <ul className="navbar-nav ms-auto">
                  <li className="nav-item">
                    <NavLink className="nav-logout" to="/login">
                      Login
                    </NavLink>
                  </li>
                </ul>
              )}
            </div>
          </div>
        </nav>
      </header>

      {bare ? (
        children
      ) : (
        <div className="container">
          <main role="main" className="pb-3 pt-4">
            {children}
          </main>
        </div>
      )}

      {!bare && (
        <footer className="border-top footer text-muted">
          <div className="container py-2" style={{ textAlign: 'center' }}>
            <span>
              &copy; 2026 <span className="text-neon-magenta">STREAM</span>
              <span className="text-neon-blue">GG</span> &middot; Data from{' '}
              <a href="https://start.gg" target="_blank" rel="noreferrer">start.gg</a>
            </span>
          </div>
        </footer>
      )}
    </>
  );
}
